
import css from 'styled-jsx/css';

export default css`.webinar {
  background: $stone;
  border-radius: 24px;
  display: flex;
  flex-direction: column;
  justify-content: stretch;
  width: 100%;

  &__image {
    border-radius: 24px 24px 0 0;
    overflow: hidden;
    position: relative;

    &::before {
      content: '';
      display: block;
      padding-top: 9 / 16 * 100%;
      position: relative;
    }

    :global(picture img) {
      height: 100%;
      object-fit: cover;
      position: absolute;
      top: 0;
      width: 100%;
    }
  }

  &__content {
    align-items: flex-start;
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    padding: 2rem;
    width: 100%;
  }

  &__title {
    margin-bottom: 1.25rem;
  }

  &__details {
    border-bottom: 1px dashed $slate;
    margin-bottom: 1.8125rem;
    width: 100%;
  }

  &__details__information {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding-bottom: 0.375rem;
  }

  &__details__cta {
    align-items: center;
    cursor: pointer;
    display: flex;

    :global(svg) {
      display: block;
      margin-left: 0.25rem;
      width: 0.375rem;
    }

    :global(&:not(.is-expanded)) {
      :global(svg) {
        transform: rotate(180deg);
      }
    }
  }

  .webinar__body {
    overflow: hidden;
    transition: max-height 0.5s ease;
  }

  &:not(.is-expanded) {
    .webinar__body {
      max-height: 0 !important;
    }

    .webinar__body > * {
      transition: opacity 1ms ease;
    }
  }

  &.is-expanded {
    .webinar__body {
      transition: max-height 0.5s ease;
    }

    .webinar__body > * {
      opacity: 1;
      transition: opacity 0.2s ease 0.5s;
    }
  }

  &__body {
    padding-top: 0.75rem;

    > * {
      opacity: 0;
      transition: opacity 0s ease 0.15s;
    }
  }

  &__subtitle {
    margin-bottom: 1.5rem;
  }

  &__cta {
    align-items: flex-end;
    display: flex;
    flex: 1 1 auto;
  }
}
`